import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Observable} from 'rxjs';
import {QMIntegration} from '@app/core/models/QMIntegration.model';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {map} from 'rxjs/operators';
import {IPosIntegrationModel} from '@app/core/models/quickpos-integration.model';
import {getCurrentState} from '@app/core/helpers';

@Injectable()
export class IntegrationService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public getIntegrations(): Observable<QMIntegration[]> {
		return this.httpService.getJson<QMIntegration[]>('integrations').pipe(map((res: QMIntegration[]) => {
			res = res.filter(r => r.id !== 9 && !r.always_enabled);

			return res;
		}));
	}

	public getIntegrationsForPayroll(): Observable<QMIntegration[]> {
		return this.httpService.getJson<QMIntegration[]>('integrations/payroll');
	}

	public getQuickPosIntegration(): Observable<IPosIntegrationModel> {
		return this.httpService.getJson('integrations/department/' + getCurrentState(this.store).session.department.id + '/quick-pos');
	}

	public patchQuickPosIntegration(integration: IPosIntegrationModel): Observable<IPosIntegrationModel> {
		return this.httpService.patchJson('integrations/department/' + getCurrentState(this.store).session.department.id + '/quick-pos', integration);
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}
}
